export enum ThemeModePreference {
  LIGHT = "LIGHT",
  DARK = "DARK",
  SYSTEM = "SYSTEM"
}

export const PREFERS_DARK_MODE = "(prefers-color-scheme: dark)";

export const PREFERRED_THEME_MODE_KEY = "preferredThemeMode";
